import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import SingleItemDetailTemplate from '../../../Reusable_Components/SingleItemDetailTemplate';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/apiConfig';
import InvoiceItemList from '../List Components/InvoiceItemListDetails';

const SingleCreditNoteDetails = () => {
  const { creditNoteId } = useParams();
  const decodedId = creditNoteId ? atob(creditNoteId) : creditNoteId;
  const id = decodedId.replace(/\D/g, '');  // Ensure we only get the numeric part
  const [creditNoteDetails, setCreditNoteDetails] = useState(null);

  const [columns, setColumnDetails] = useState([]);

  useEffect(() => {

    fetchCreditNoteDetails();
  }, [creditNoteId]);

    const fetchInvoiceDetails = async (invoiceId) => {
        try {
            const response = await axios.get(`${API_DOMAIN}${API_ROUTES.invoice}${invoiceId}/`, { headers });
            return response.data;
        } catch (error) {
            console.error('Error fetching invoice details:', error);
        }
    };


      const fetchCreditNoteDetails = async () => {
        try {
            const response = await axios.get(`${API_DOMAIN}${API_ROUTES.credit_note}${id}/`, { headers });
            const invoiceDetails = await fetchInvoiceDetails(response.data.invoice);
            const updatedResponseData = { ...response.data, 'invoice_number': invoiceDetails.invoice_number };

            const extractedColumns = Object.keys(updatedResponseData);
            const excludedColumns = ['id', 'created_at', 'updated_at', 'items', 'invoice'];
            const columnsArray = extractedColumns
            .filter((column) => !excludedColumns.includes(column))
            .map((column) => ({
                label: column.charAt(0).toUpperCase() + column.slice(1).replace('_', ' '),
                field: column,
            }));

            setColumnDetails(columnsArray);
            setCreditNoteDetails(updatedResponseData);
        } catch (error) {
            console.error('Error fetching credit note details:', error);
        }
    };


  return (
    <div>
      {creditNoteDetails ? (
        <div>
        <SingleItemDetailTemplate details={creditNoteDetails} columns={columns} />

        Items:

        <InvoiceItemList invoice={creditNoteDetails.invoice}/>
        </div>
       
      ) : (
        <p>Loading credit note details...</p>
      )}
    </div>
  );
};

export default SingleCreditNoteDetails;